import React from 'react';
import './PageWrapper.css';

/**
 * PageWrapper Component
 * Provides consistent page structure for all dashboard pages
 * 
 * Props:
 * - title: Page title (required)
 * - description: Optional page description
 * - actions: Optional array of action buttons
 * - children: Page content
 */
const PageWrapper = ({ title, description, actions, children }) => {
  return (
    <div className="page-wrapper">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <h1 className="page-title">{title}</h1>
          {description && <p className="page-description">{description}</p>}
        </div>
        
        {actions && actions.length > 0 && (
          <div className="page-actions">
            {actions.map((action, index) => (
              <button
                key={index}
                className={`page-action-btn ${action.variant || 'primary'}`}
                onClick={action.onClick}
                disabled={action.disabled}
              >
                {action.icon && <span className="action-icon">{action.icon}</span>}
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Page Content */}
      <div className="page-body">
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;
